// Chakra imports
import {
  Portal,
  useDisclosure,
  Stack,
  Box,
  useColorMode,
  Flex,
  useColorModeValue,
  HStack,
} from "@chakra-ui/react";
import DiscordButton from "components/Buttons/Discord";
import Configurator from "components/Configurator/Configurator";
import Footer from "components/Footer/Footer.js";
import {
  ArgonLogoDark,
  ArgonLogoLight,
  ChakraLogoDark,
  ChakraLogoLight,
  SWDLogo,
} from "components/Icons/Icons";
import { useLocation } from "react-router-dom";
// Layout components
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import React, { useState, useEffect } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import routes from "routes.js";
// Custom Chakra theme
import FixedPlugin from "../components/FixedPlugin/FixedPlugin";

import LoadingModal from "components/Modals/Loading";
import MaintanceModal from "components/Modals/Maintance"

// Custom components
import MainPanel from "../components/Layout/MainPanel";
import PanelContainer from "../components/Layout/PanelContainer";
import PanelContent from "../components/Layout/PanelContent";
import axios from "axios";

import apiUrl from "variables/api";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useMediaQuery } from "react-responsive";

import { useHistory } from "react-router-dom";
import { BsWindowSidebar } from "react-icons/bs";

export default function Dashboard(props) {
  const location = useLocation();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const { ...rest } = props;
  // states and functions
  const [fixed, setFixed] = useState(false);
  const [roles,setRoles] = useState("")
  const { colorMode } = useColorMode();

  // functions for changing the states from components
  const getRoute = () => {
    return window.location.pathname !== "/swd/full-screen-maps";
  };
  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else if (routes[i].category) {
        let categoryActiveRoute = getActiveRoute(routes[i].views);
        if (categoryActiveRoute !== activeRoute) {
          return categoryActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };
  const getActiveRouteCategoryName = () => {
    const currentPath = window.location.href;
    const category = currentPath.split("/").slice(-2, -1)[0];
    const categoryList = {
      another: "Inne",
      "k-t": "Wydział Kwatermistrzowski",
      "k-r": "Wydział Kontrolno Rozpoznawczy",
      "r-z": "Raporty zmianowe",
      "r-j": "Raporty jednostek",
      school: "Szkoła Podoficerska",
      manage: "Zarząd",
      technical: "Techniczne",
      sgpr: "SGPR",
      sgmed: "SGMed",
      sgrt: "SGRT",
      sgrchem: "SGRChem",
    };
    return categoryList[category];
  };
  // This changes navbar state(fixed or not)
  const getActiveNavbar = (routes) => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].category) {
        let categoryActiveNavbar = getActiveNavbar(routes[i].views);
        if (categoryActiveNavbar !== activeNavbar) {
          return categoryActiveNavbar;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          if (routes[i].secondaryNavbar) {
            return routes[i].secondaryNavbar;
          }
        }
      }
    }
    return activeNavbar;
  };
  const getRoutes = (routes) => {
    const userRoles = localStorage.getItem('roles') || [];
    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.category === "account") {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/swd") {
        // console.log(prop.path, prop);
        if (prop.perms && !userRoles.includes(prop.perms)) {
          return null;
        }
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const { isOpen, onOpen, onClose } = useDisclosure();
  document.documentElement.dir = "ltr";

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isMaintance, setIsMaintance] = useState(false);
  const [isProblem, setIsProblem] = useState(false);
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    console.log(11)
    axios
      .get(apiUrl + "/auth/verify", {
        headers: { "x-access-token": localStorage.getItem("token") },
      })
      .then((response) => {
        console.log(123)
        console.log(response.data);
        // Ustawiamy wartość zmiennej isLoggedIn na podstawie wartości zwróconej przez API
        setIsLoggedIn(response.data.verified);
        localStorage.setItem("avatar", response.data.user.avatar);
        localStorage.setItem("nickname", response.data.user.nickname);
        localStorage.setItem("id", response.data.user.id);
        // localStorage.setItem("test", {
        //   avatar: response.data.user.avatar,
        //   nickname: response.data.user.nickname,
        // });
        setTimeout(() => {
        localStorage.setItem("roles", response.data.user.roles);
        }, 2000)
        setIsReady(true);
        setTimeout(() => {
          if(response.data.zoltaKartka) {
            window.location.href = response.data.zoltaKartka;
          }
        }, 2000)
      })
      .catch((error) => {
        console.log(1)
        if (error.response?.status === 425) {
          console.log(23)
          setIsMaintance(true)
        } else if (error.response?.status !== 400 && error.response?.status !== 401) {
          console.log(3)
          setIsMaintance(true)
          setIsProblem(true)
        }
        console.error(error);
        setIsReady(true);
      });
  }, [location.pathname]);
  // Chakra Color Mode
  return (
    <div>
      {isMaintance ? 
      (
        <MaintanceModal isOpen={true} problem={isProblem} />
      ) 
      :
      (isLoggedIn ? (
        <Box>
          {!isMobile && (
            <Sidebar
              routes={routes}
              logo={
                <Stack direction="row" align="center" justify="center">
                  <SWDLogo w="100px" h="100px" />
                </Stack>
              }
              display="none"
              {...rest}
            />
          )}
          <MainPanel
            w={{
              base: "100%",
              xl: "calc(100% - 275px)",
            }}
          >
            <Portal>
              <AdminNavbar
                onOpen={onOpen}
                brandText={getActiveRoute(routes)}
                category={getActiveRouteCategoryName()}
                secondary={getActiveNavbar(routes)}
                fixed={fixed}
                {...rest}
              />
            </Portal>
            {getRoute() ? (
              <PanelContent>
                <PanelContainer>
                  <Switch>
                    {getRoutes(routes)}
                    <Redirect from="/swd" to="/swd/homepage" />
                  </Switch>
                </PanelContainer>
              </PanelContent>
            ) : null}
            <Footer />
          </MainPanel>
          <ToastContainer
            position="bottom-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme={colorMode === "dark" ? "dark" : "light"}
          />
        </Box>
      ) : isReady ? (
        <Redirect to="/auth/signin" />
      ) : (
        <LoadingModal isOpen={true} />
      ))}
    </div>
  );
}
